/**
 * Routes that belong under the "More" section in the navbar.
 *
 * BottomNav and Header use this to keep the More tab highlighted when the
 * user has drilled into one of these sub-pages, so the navigation never
 * feels "broken" after a tap from /more.
 */
const MORE_SECTION_PATHS = ["/more", "/community", "/committee", "/contribute", "/about"];

export function isInMoreSection(pathname: string): boolean {
  return MORE_SECTION_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
